export const constants = {
  MFE_APP_PROVIDER_NAME: 'appProvider',
  MFE_EXPOSED_PATH: './AppProvider',
};
